import marked from 'marked';
import ApiMetadata from './Metadata';

import {
  RequestGroupComponent,
  ErrorMessagesComponent,
  objectToArray,
  objectToScalarArray,
  formatAuthTypes,
} from './DocGenerator';

var pageController;

var API_URL;

marked.setOptions({
  smartypants : true
});

function activateStatic(page, container) {
  // TODO add caching
  fetch(page.source)
    .then(resp => {
      if (!resp.ok) {
        throw new Error(`Received error status response: ${resp.status}`);
      }

      return resp.text();
    })
    .then(data => {
      container.innerHTML = marked(data);
    })
    .catch(err => {
      // TODO improve the way this error looks
      container.textContent = err.message;
    });
}

function initRequestGroup(page) {
  const requestGroupName = page.title;

  let requestGroupDefinition = Object.assign({}, ApiMetadata.getRequestGroupDefinition(requestGroupName));

  requestGroupDefinition.methods = objectToArray(
    requestGroupDefinition.methods,
    'methodName'
  );

  requestGroupDefinition.methods.forEach(method => {
    method.parameters = objectToArray(method.parameters, 'paramName');

    let objects = [];

    // find object params
    method.parameters.forEach((param, idx) => {
      if (param.type === 'object') {
        objects.push({
          idx: idx + 1,
          paramName: param.paramName,
          fields: objectToArray(param.fields, 'paramName'),
        });
      }
    });

    let offset = 0;
    if (objects.length) {
      objects.forEach(obj => {
        obj.fields.forEach(field => {
          field.paramName = `${obj.paramName}.${field.paramName}`;
          method.parameters.splice(obj.idx + offset, 0, field);
          offset++;
        });
      });
    }

    method.parameters.forEach(param => {
      if (param.valuesDescriptions !== undefined) {
        param.valuesDescriptions = objectToScalarArray(param.valuesDescriptions);
      }

      param.requiredForAuthTypeString = formatAuthTypes(param.requiredForAuthType);
      param.disallowedForAuthTypeString = formatAuthTypes(param.disallowedForAuthType);
    });

    method.allowedAuthTypesString = formatAuthTypes(method.allowedAuthTypes);

    if (method.resultDefinition) {
      method.resultDefinition = objectToArray(method.resultDefinition, 'resultFieldName');
      method.resultDefinition.forEach(r => r.authTypeFilterString = formatAuthTypes(r.authTypeFilter));
    }

    if (method.subversions) {
      method.resultDefinitionSubversions =
        Object.keys(method.resultDefinitionSubversions).map(subversionName => {
          let rDef = objectToArray(
            method.resultDefinitionSubversions[subversionName],
            'resultFieldName'
          );
          rDef.forEach(r => r.authTypeFilterString = formatAuthTypes(r.authTypeFilter));

          return {
            subversionName,
            resultDefinition: rDef
          };
        });
    }
  });

  let vars = {
    API_URL,
    requestGroupName,
    requestGroupDefinition
  };

  return (
    <RequestGroupComponent requestGroup={vars} />
  );
}

function initErrorMessages() {
  return (
    <ErrorMessagesComponent
      errorCodes={objectToScalarArray(ApiMetadata.getErrorCodes())}
    />
  );
}

function init(pc, config) {
  var requestGroups = ApiMetadata.getRequestGroupNames();

  pageController = pc;

  API_URL = config.API_URL;

  const staticContainer = (
    <div class="page-container page-doc-viewer-static" />
  );
  pageController.addPageContainerToDom(staticContainer);

  config.pages.forEach(function(page) {
    page.handler = activateStatic;
    page.container = staticContainer;

    pageController.addPage(page);
  });

  requestGroups.forEach(function(rg) {
    const def = ApiMetadata.getRequestGroupDefinition(rg);
    const page = {
      title          : rg,
      path           : rg,
      scrollSelector : '.requestGroup-' + rg,
      subsections    : [],
      init: initRequestGroup,
    };

    if (def.methods) {
      Object.keys(def.methods).forEach(function(methodName) {
        page.subsections.push({
          title    : methodName,
          path     : methodName,
          scrollSelector : '.method-' + methodName
        });
      });
    }

    pageController.addPage(page);
  });

  pageController.addPage({
    title : 'Errors',
    path : 'Errors',
    init: initErrorMessages,
  });

  document.body.addEventListener('click', e => {
    const { target } = e;
    if (!target.matches('.btn-doc-link')) {
      return;
    }

    const paramName = target.getAttribute('data-alias');
    const tr = target.closest('table')?.querySelector(`.tr-${paramName}`);
    if (tr) {
      tr.scrollIntoView();
    }
  });
}

export default {
  init : init
};
